export const REQUEST_DEPARTMENTS = "request_departments"
export const FETCH_DEPARTMENTS_SUCCESS = "fetch_departments_success"
export const FETCH_DEPARTMENTS_FAILURE = "fetch_departments_failure"

export const CLEAR_DEPARTMENTS_STATE = "clear_departments_state"